<template>
    <div
        style="background: #f5faff; border: 2px solid #b3d8fd; border-radius: 16px; padding: 2rem;">
        <span style="font-weight: bold; color: #183a7d; font-size: 1.2rem;">Atención</span>
        <p style="margin-top: 10px; color: #333;">
            Las facturas de Onmex se emiten por defecto a una persona genérica. Si necesitas la factura a nombre de una persona física o moral, debes enviar un correo a
            <a href="mailto:pagos@onmex.mx" style="color: #1976d2; text-decoration: underline;">pagos@onmex.mx</a>
            con el asunto <b>"Solicitud ficha + tu CURP"</b> y la constancia de situación fiscal de la persona correspondiente.<br>
            El plazo máximo para solicitar una refacturación es <b>hasta el día 5 del mes siguiente</b>.
        </p>
    </div>
</template>

<script>
    export default {
        name: 'BillingLegend',
    }
</script>

